export default __webpack_public_path__ + "static/media/fun2fit.981ae54f.png";